import React, { useCallback, useEffect, useState } from 'react';

import { CircularProgress } from '@material-ui/core';
import Error from '../../pages/_error';
import MuiAlert from '@material-ui/lab/Alert';
import NotLoggedIn from '../Auth/notLoggedIn';
import Paper from '@material-ui/core/Paper';
import RefreshTokens from '../../utils/resfreshTokens';
import SideDrawer from './sideDrawer';
import Snackbar from '@material-ui/core/Snackbar';
import UseIdleTimer from './UseIdleTimer';
import actions from '../../reduxStore/action';
import canUserAcces from 'utils/canUserAcces';
import { connect } from 'react-redux';
import { useRouter } from 'next/router';
import useStyles from '../../assets/jss/layout-styles';

const DefaultLayout = (props) => {
    const {
        auth: { user }
    } = props;
    const router = useRouter();
    const classes = useStyles();
    const [open, setOpen] = useState(false);
    const [hasAccess, setHasAccess] = useState();
    const [error, setError] = useState();
    const [vertical] = useState('top');
    const [horizontal] = useState('center');
    function Alert(propsParam) {
        return <MuiAlert elevation={6} variant='filled' {...propsParam} />;
    }
    useEffect(() => {
        userHasAccess();
    }, [userHasAccess]);

    const userHasAccess = useCallback(async () => {
        setHasAccess(await canUserAcces(user, router.route, router.query));
    }, [user]);
    const openSnackBar = (_error) => {
        if (_error?.response) {
            setError(`${_error.response.data.message}
      ${_error.message}
      ${_error.response.config.url}`);
        } else {
            setError('An Error Occurred');
        }
        setOpen(true);
    };
    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpen(false);
        setError('');
    };
    // Redirect if not logged in. Render blank page for second...
    if (!props.auth.isLoggedIn) {
        router.replace('/login');
    }
    return !props.auth.isLoggedIn ? (
        <NotLoggedIn />
    ) : (
        <>
            <RefreshTokens toggleSnackBar={openSnackBar} />
            <UseIdleTimer />
            <div className={classes.root}>
                <SideDrawer user={user} />
                <Paper elevation={0} className={classes.content}>
                    <div className='container'>
                        {/* {canUserAcces(user, router.route, router.query) */}
                        {hasAccess ? (
                            React.Children.map(props.children, (child) => {
                                if (React.isValidElement(child)) {
                                    return React.cloneElement(child, { user });
                                }
                                return child;
                            })
                        ) : hasAccess === undefined ? (
                            <CircularProgress />
                        ) : (
                            <Error statusCode={403} />
                        )}
                    </div>
                </Paper>
            </div>
            <Snackbar open={open} autoHideDuration={6000} onClose={handleClose} anchorOrigin={{ vertical, horizontal }}>
                <Alert onClose={handleClose} severity='error'>
                    {'There was an error!'}
                    <p style={{ color: '#FFFFFF' }}>{error}</p>
                </Alert>
            </Snackbar>
        </>
    );
};
const mapStateToProps = (state) => state;
export default connect(mapStateToProps, actions)(DefaultLayout);
